import { render, staticRenderFns } from "./report-powerbi-container.vue?vue&type=template&id=65cbaedd"
import script from "./report-powerbi-container.vue?vue&type=script&lang=ts"
export * from "./report-powerbi-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports